import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "badgeList", "languageSelect", "submitButton"];

  async submit (e) {
    e.preventDefault();
    this.disableSubmit();

    const json = await this.postForm();

    if (!json.success) {
      this.error(json.error);
      // re-enable submit after error
      this.resetForm();
      this.enableSubmit();
      return;
    }

    this.badgeListTarget.insertAdjacentHTML("beforeend", json.badge_component);
    this.toggleLanguageOption(json.language_code, true);

    this.resetForm();
    this.updatePrompt();
    this.enableSubmit();
    this.updateLanguageDropdownDisabled();
  }

  async handleBadgeRemoved (e) {
    const { key } = e.detail;
    const json = await this.deleteLanguage(key);
    if (!json.success) return this.error(json.error);

    this.toggleLanguageOption(key, false);
    this.updatePrompt();
    this.enableSubmit();
    this.updateLanguageDropdownDisabled();
  }

  resetForm () {
    this.formTarget.reset();
    this.languageSelectTarget.value = "";
  }

  disableSubmit () {
    this.submitButtonTarget.setAttribute("disabled", "true");
  }

  enableSubmit () {
    this.submitButtonTarget.removeAttribute("disabled");
  }

  updateLanguageDropdownDisabled () {
    const badgeCount = this.badgeListTarget.querySelectorAll(".wg-badge").length;
    const maxLanguages = parseInt(this.badgeListTarget.dataset.maxLanguages, 10);
    const shouldDisable = badgeCount >= maxLanguages;

    this.languageSelectTarget.disabled = shouldDisable;
    // also disable submit button
    if (shouldDisable) this.disableSubmit();
  }

  error (msg) {
    alert(msg);
    this.resetForm();
  }

  updatePrompt () {
    const count = this.badgeListTarget.querySelectorAll(".wg-badge").length;
    const prompt = this.languageSelectTarget.querySelector("option[value='']");
    if (!prompt) return;

    prompt.textContent = count === 0
      ? this.badgeListTarget.dataset.noLanguagesText
      : this.badgeListTarget.dataset.selectedLanguagesText.replace("%{count}", count);
  }

  async postForm () {
    const res = await fetch(this.formTarget.action, {
      method: "POST",
      headers: {Accept: "application/json"},
      body: new FormData(this.formTarget)
    });
    return res.json();
  }

  async deleteLanguage (code) {
    const res = await fetch(`/admin/localization/languages/${code}`, {
      method: "DELETE",
      headers: {
        Accept:
        "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
      }
    });
    return res.json();
  }

  toggleLanguageOption (code, disable = true) {
    const option = this.languageSelectTarget.querySelector(`option[value="${code}"]`);
    if (option) {
      option.disabled = disable;
      option.hidden = disable;
    }
  }
}
